import React from 'react';
import { useIntl } from 'react-intl';
import styles from './AlokaHowItWorks.module.css';
import { LiaSearchSolid } from 'react-icons/lia';
import { TbNumber2 } from 'react-icons/tb';
// import { TbLocation } from 'react-icons/tb';
import { LiaLocationArrowSolid } from 'react-icons/lia';

const AlokaHowItWorks = () => {
  const intl = useIntl();

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>
        {intl.formatMessage({
          id: 'alokaHowItWorks.title',
        })}
      </h1>
      <p className={styles.subtitle}>
        {intl.formatMessage(
          { id: 'alokaHowItWorks.subtitle' },
          {
            subtitle2Mins: <b>{intl.formatMessage({ id: 'alokaHowItWorks.subtitle2Mins' })}</b>,
          }
        )}
      </p>

      <div className={styles.columns}>
        {/* Left Container - User perspective */}
        <div className={styles.column}>
          <div className={styles.titleContainer}>
            <div className={styles.containerIcon}>
              <LiaSearchSolid />
            </div>
            <div className={styles.eachTtitleContainer}>
              <p className={styles.itemTitle}>
                <b>{intl.formatMessage({ id: 'alokaHowItWorks.search' })}</b>
              </p>
            </div>
          </div>

          <div className={styles.stepRow}>
            <span className={styles.stepNumber}>1</span>
            <p className={styles.stepText}>
              {intl.formatMessage({ id: 'alokaHowItWorks.whatYouNeed' })}
            </p>
          </div>
          {/* ---------------------------------- */}
          <div className={styles.stepRow}>
            <span className={styles.stepNumber}>2</span>
            <p className={styles.stepText}>
              {intl.formatMessage({ id: 'alokaHowItWorks.bookAndReceive' })}
            </p>
          </div>
          {/* ----------------------------------------- */}
          <div className={styles.stepRow}>
            <span className={styles.stepNumber}>3</span>
            <p className={styles.stepText}>
              {intl.formatMessage({ id: 'alokaHowItWorks.recordAndReturn' })}
            </p>
          </div>
          <div className={styles.stepRow}>
            <span className={styles.stepNumber}></span>
            <p className={styles.stepText}>
              {intl.formatMessage({ id: 'alokaHowItWorks.withoutComplications' })}
            </p>
          </div>
        </div>

        {/* Right Container - Owner perspective */}

        <div className={styles.column}>
          <div className={styles.titleContainer}>
            <div className={`${styles.containerIcon} ${styles.containerIconTransform} `}>
              <LiaLocationArrowSolid />
            </div>
            <div className={styles.eachTtitleContainer}>
              <p className={styles.itemTitle}>
                <b>{intl.formatMessage({ id: 'alokaHowItWorks.upload' })}</b>
              </p>
            </div>
          </div>

          <div className={styles.stepRow}>
            <span className={styles.stepNumber}>1</span>
            <p className={styles.stepText}>
              {intl.formatMessage({ id: 'alokaHowItWorks.yourEquipment' })}
            </p>
          </div>
          {/* ---------------------------------- */}
          <div className={styles.stepRow}>
            <span className={styles.stepNumber}>2</span>
            <p className={styles.stepText}>
              {intl.formatMessage({ id: 'alokaHowItWorks.setPriceAvailability' })}
            </p>
          </div>

          {/* ----------------------------------------- */}
          <div className={styles.stepRow}>
            <span className={styles.stepNumber}>3</span>
            <p className={styles.stepText}>
              {intl.formatMessage({ id: 'alokaHowItWorks.deliverAndEarn' })}
            </p>
          </div>
          <div className={styles.stepRow}>
            <span className={styles.stepNumber}></span>
            <p className={styles.stepText}>
              {intl.formatMessage({ id: 'alokaHowItWorks.insuranceIncluded' })}
            </p>
          </div>
        </div>
        {/* <div className={styles.column}>
          <p className={styles.itemTitle}>{intl.formatMessage({ id: 'alokaHowItWorks.upload' })}</p>
          <p className={styles.itemText}>
            {intl.formatMessage({ id: 'alokaHowItWorks.yourEquipment' })}
          </p>

          <p className={styles.itemTitle}>
            {intl.formatMessage({ id: 'alokaHowItWorks.setPriceAvailability' })}
          </p>

          <p className={styles.itemTitle}>
            {intl.formatMessage({ id: 'alokaHowItWorks.deliverAndEarn' })}
          </p>
          <p className={styles.note}>
            {intl.formatMessage({ id: 'alokaHowItWorks.insuranceIncluded' })}
          </p>
        </div> */}
      </div>
    </div>
  );
};

export default AlokaHowItWorks;
